"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BillingAgreement = /** @class */ (function () {
    function BillingAgreement(props) {
        this.billingAgreementId = props.billingAgreementId;
        this.reference = props.reference;
        this.clientId = props.clientId;
        this.customerAccountId = props.customerAccountId;
        this.addressId = props.addressId;
        this.bic = props.bic;
        this.iban = props.iban;
        this.paymentMethodCode = this.getpaymentMethodCode(props.paymentMethodCode);
        this.directDebit = props.directDebit;
        this.dematerialization = props.dematerialization;
        this.displayRelMedInvoices = props.displayRelMedInvoices;
    }
    BillingAgreement.prototype.getpaymentMethodCode = function (code) {
        if (code === 0)
            return 'maturity';
        return 'periodic';
    };
    return BillingAgreement;
}());
exports.default = BillingAgreement;
